/**
 * Common Zod schemas shared across Excel editor tools.
 */
import { z } from "zod";
// ═══════════════════════════════════════════════════════════════════════════
// RANGE SPEC — Numeric range addressing (1-indexed)
// ═══════════════════════════════════════════════════════════════════════════
export const RangeSpecSchema = z.object({
    startRow: z.number().int().min(1).describe("Start row (1-indexed)"),
    endRow: z.number().int().min(1).describe("End row (1-indexed)"),
    startCol: z.number().int().min(1).describe("Start column (1-indexed, A=1)"),
    endCol: z.number().int().min(1).describe("End column (1-indexed)"),
});
